import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconTextColumns16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconTextColumns16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3.5 5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm0 4a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM3 7.5a.5.5 0 0 1 .5-.5H5a.5.5 0 0 1 0 1H3.5a.5.5 0 0 1-.5-.5m.5 3.5a.5.5 0 0 0 0 1H5a.5.5 0 0 0 0-1zM9 5.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M9.5 9a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM9 7.5a.5.5 0 0 1 .5-.5H11a.5.5 0 0 1 0 1H9.5a.5.5 0 0 1-.5-.5m.5 3.5a.5.5 0 0 0 0 1H11a.5.5 0 0 0 0-1z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconTextColumns16);
